import {
  Injectable
} from '@angular/core';
import {
  DataServiceService
} from './data-service.service';

@Injectable({
  providedIn: 'root'
})
export class ConsentService {

 

  public readAndUnderstoodIFAsBacktestingDisclosuresAndIndexDescriptions = {
    id: `2025-12-29-readAndUnderstoodIFAsBacktestingDisclosuresAndIndexDescriptions`,
    question: `<ol>
    <li>I have read and understand IFA's Back-testing Disclosures and Index Descriptions.</li>
    <li>I have access to sufficient resources and possess the financial expertise to independently analyze hypothetical back-tested performance data.</li>
    <li>I understand the RISKS, LIMITATIONS and ASSUMPTIONS made in calculating the hypothetical back-tested performance data.</li>
    <li>I would like information on investing and in particular hypothetical back-tested data of indexes, index portfolios, mutual funds and exchange traded funds.</li>
    <li>The use of hypothetical back-tested performance data is relevant to my investment analysis, objectives, and financial situation. By confirming below, I am requesting access to this data.</li>
    </ol>`,
    textTrue: `Yes`,
    textFalse: `No`,
    answer: '',
    answerDate: null
  };

  //We will use an array to look up the consent by id later.
  privateConsentArray: Array < any > = [
    this.readAndUnderstoodIFAsBacktestingDisclosuresAndIndexDescriptions
  ];


  constructor(private data2Service: DataServiceService) {

  }
 isFullyConsented(caller:string=""){
// $&(`Consent Service > isFullyConsented ${caller}` ,this.privateConsentArray)
    return this.privateConsentArray.every(x=>x.answer=='true');
  }



}